import OrganizationTab from './OrganizationTab'
export default OrganizationTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/OrganizationTab/index.js